import {TreeViewBaseItem} from '@mui/x-tree-view';
import {ExtendedTreeItemProps} from '../../shared/interfaces';

type ApiItem = {
  id: string;
  text: string;
  parent?: string;
  type?: string;
  isGroup?: boolean;
  isLocked?: boolean;
  securityGroupId?: string;
};

export interface ListItem extends TreeViewBaseItem<ExtendedTreeItemProps> {
  selected?: boolean;
  children?: ListItem[];
  parent?: string | null;
  type?: string;
  isGroup?: boolean;
  isLocked?: boolean;
  text?: string;
  securityGroupId?: string | null;
}

export const buildTree = (
  items: ApiItem[] = [],
  selectedItems: string[] = []
): {roots: ListItem[]; selectedSet: Set<string>} => {
  const map = new Map<string, ListItem>();
  const roots: ListItem[] = [];

  const selectedSet = new Set(selectedItems.map(String));

  for (const item of items) {
    const id = String(item.id);
    const parent = item.parent != null ? String(item.parent) : null;

    const selected = selectedSet.has(id);

    map.set(id, {
      id,
      label: item.text,
      selected,
      parent,
      type: item.type ?? '',
      isGroup: item.isGroup ?? false,
      isLocked: item.isLocked ?? false,
      text: item.text ?? id,
      children: [],
      securityGroupId: item.securityGroupId ?? null,
    });
  }

  for (const item of items) {
    const id = String(item.id);
    const parent = item.parent != null ? String(item.parent) : null;
    const node = map.get(id);
    if (!node) continue;

    if (parent && parent !== '#' && map.has(parent)) {
      if (selectedSet.has(id)) {
        selectedSet.add(parent);
      }
      map.get(parent)!.children!.push(node);
    } else {
      if (selectedSet.has(id)) {
        selectedSet.add(id);
      }
      roots.push(node);
    }
  }

  return {roots, selectedSet};
};

export const filterByIds = <T extends {id: string | number}>(
  list: T[],
  ids: (string | number)[] | null,
  type?: string
): T[] => {
  if (!ids || ids.length === 0) return [];
  const idSet = new Set(ids.map(String));
  return list
    .filter((item) => idSet.has(String(item.id)))
    .map((item) => ({...item, type}));
};

export function setsAreEqual(set1: Set<string>, set2: Set<string>): boolean {
  if (set1.size !== set2.size) {
    return false;
  }
  for (const value of set1) {
    if (!set2.has(value)) {
      return false;
    }
  }

  // If all elements of set1 were found in set2 and the sizes match, they are equal.
  return true;
}
